import React from 'react';

const GameProviderList = ({ list, onNavigate, title }) => {
    return (
        <div className="padding-router-view">
            <div>
                <main className="container p-0">
                    <div className="pt-1 pb-3 text-white-v1 w-scroll-height-casino">
                        <div className="x-category-provider js-game-scroll-container js-game-container animated animatedFadeInUp fadeInUp ">
                            <div className="-games-list-container container">
                                {title && <div className="sb-titlebar">{title}</div>}
                                <nav className="nav-menu" id="navbarProvider">
                                    <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp ">
                                        {(list || []).map((listitem, i) => (
                                            <li key={i} className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2">
                                                <a href="/" onClick={(e) => onNavigate(e, listitem)}>
                                                    <div
                                                        className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                        data-status="-cannot-entry -untestable bg-card-item"
                                                    >
                                                        <div className="-inner-wrapper card-width-banner-games">
                                                            <div></div>
                                                            <picture>
                                                                <img alt=""
                                                                    role="button"
                                                                    className="w-100 hover-slot hoverTextCss"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    src={listitem.image}
                                                                />
                                                            </picture>
                                                            <div className="-overlay d-none d-lg-block">
                                                                <div className="-overlay-inner">
                                                                    <div className="-wrapper-container">
                                                                        <button
                                                                            role="button"
                                                                            className="-btn v-login js-account-approve-aware"
                                                                            onClick={(e) => onNavigate(e, listitem)}
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={20}
                                                                                height={20}
                                                                                fill="currentColor"
                                                                                className="bi bi-play-circle-fill m-2"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                            </svg>
                                                                            <span className="-text-btn">เข้าเล่น</span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div><div></div></div>
                                                    </div>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default GameProviderList;
